import Cookies from "js-cookie";

interface LanguageService {
    getCurrent() : string;
    getCurrentInShortFormat(): string;
    setCurrent(language: string) : void;
}

const getLangFromDocument = (): string | undefined => {
    if (typeof document === 'undefined') return undefined;
    const raw =
        document.documentElement.lang?.trim() ||
        document.documentElement.getAttribute('lang')?.trim();
    return raw || undefined;
};

const getCurrent = () => {
    const fromCookie = Cookies.get('language');
    if (fromCookie) return fromCookie;
    return getLangFromDocument() ?? 'en';
};

const getCurrentInShortFormat = () => {
    const fullLang = languageService.getCurrent();
    return fullLang.split("-")[0];
}

const setCurrent = (language: string) => {
    Cookies.set('language', language);
}

const languageService : LanguageService = {getCurrent, setCurrent, getCurrentInShortFormat};

export default languageService;